import React from "react";
import useReveal from "../hooks/useReveal";
import PageHero from "../components/PageHero";
import Services from "../components/Services";
import HowItWorks from "../components/HowItWorks";

export default function ServicesPage() {
  useReveal();
  return (
    <>
      <PageHero eyebrow="Our Services" title="The VIIMII Menu" subtitle="Tap any therapy to pick your exact sub-services and book in seconds." />
      <Services />
      <HowItWorks />
    </>
  );
}
